import axios from "axios";
import * as types from '../mutation-types'

const state = {
  users: [],
  currentUser: {},
}

const actions = {
  fetchCurrentUserData({commit}, id) {
    /* eslint-disable-next-line */
    return new Promise(async (res, rej) => {
      try {
        const {data} = await axios.get(`/user/${id}`)

        commit(types.FETCH_EDIT_USER_DATA_SUCCESS, data)

        res()
      } catch (e) {
        commit(types.FETCH_EDIT_USER_DATA_FAILURE)

        rej()
      }
    })
  }
}

const mutations = {
  [types.FETCH_EDIT_USER_DATA_SUCCESS](state, data) {    
    state.currentUser = data
  }
}

const getters = {
  users: state => state.users,
  currentUser: state => state.currentUser,
}

export default {
  state,
  mutations,
  getters,
  actions,
}
